export const getaccount= "https://v3.dhundhoo.com/accounts/get";
export const accountmy="https://v4.dhundhoo.com/v2/account/my" ; 
export const updateaccount="https://v3.dhundhoo.com/account/addPiolet";
// export const updateaccount="https://v3.dhundhoo.com/account/add";
export const removeaccount="https://v3.dhundhoo.com/account/remove"
export const isPhoneNumber = (number) => {
    const phoneRegex = /^\+?\d{10,12}$/;
    return phoneRegex.test(number);
  };
export const notificationlogsendpoint="https://v3.dhundhoo.com/reports/notificationLogs";
export const myThings= "https://v4.dhundhoo.com/v2/things/my";
export const journeyReportEndpiont= "https://v3.dhundhoo.com/reports/journeysReport";
export const geofenceReportEndpiont= "https://v3.dhundhoo.com/reports/geofenceReport";
export const ignitionReportEndpoint="https://v3.dhundhoo.com/reports/ignitionReport";
export const vehiclePerformanceEndpoint="https://v3.dhundhoo.com/reports/vehiclePerformanceReport";
export const trackingReportEndpoint="https://v3.dhundhoo.com/reports/trackingReport";
export const stoptimingreportapiendpoint='https://v3.dhundhoo.com/reports/stopsTimingReport';
export const routeDeviationReportendpoint="https://v3.dhundhoo.com/reports/routeDeviationReport"
export const haltreportendpoint='https://v3.dhundhoo.com/reports/haltReport';
export const distancereportendpoint='https://v3.dhundhoo.com/reports/distanceReport';
export const daywisedistancereportendpoint='https://v3.dhundhoo.com/reports/distanceReportByDate';
export const stopdistancereportendpoint='https://v3.dhundhoo.com/reports/stopDistanceReport';
export const getGeofenceendpoint='https://v3.dhundhoo.com/thing/getGeoFence';
export const vehiclereportendpoint='https://v3.dhundhoo.com/reports/vehicleReport';
export const attendancereportendpoint="https://v3.dhundhoo.com/reports/reports/access";
export const cachementreportendpoint='https://v3.dhundhoo.com/reports/catchmentReport';
export const vendorAuthApi='https://v3.dhundhoo.com/vendor/authorize';
export const vendorThingApi='https://v3.dhundhoo.com/vendor/thing/get';
    // vendorThingApi: `${BASE_API}/vendor/thing/get`,
export const vendorThingUpdatesApi=`https://v3.dhundhoo.com/vendor/thing/updates`;
    // vendorThingUpdatesApi: `${BASE_API}/vendor/thing/updates`,
export const vendorThingTrackApi=`https://v3.dhundhoo.com/vendor/thing/thingtrack`;
export const vendorThingDeviceDetailsApi = `https://v3.dhundhoo.com/vendor/thing/devicedetails`
export const GOOGLE_MAPS_API_KEY = "AIzaSyDv1tiSz3aXov0aqMcKu-OflzIIr9XK3mk";
export const GOOGLE_MAPS_LIBRARIES = ["geometry", "drawing", "places"];
